"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpiredTimeout = void 0;
const literals_1 = __importDefault(require("../literals"));
const trackingActions = __importStar(require("../tracking"));
const useExpiredTimeout = (props) => {
    const onClick = () => {
        var _a;
        (_a = props.tracker) === null || _a === void 0 ? void 0 : _a.track(trackingActions.TIMEOUT_MODAL_EXIT_LINK);
        props.redirect.goToLogin();
    };
    const onLinkClick = () => {
        var _a;
        (_a = props.tracker) === null || _a === void 0 ? void 0 : _a.track(trackingActions.TIMEOUT_MODAL_EXIT_LINK);
        props.redirect.goToPublic();
    };
    const { translate } = props;
    return {
        onClick,
        onLinkClick,
        isOpen: props.isOpen,
        translations: {
            title: translate(literals_1.default.TIMEOUT.MODAL_EXPIRED.TITLE),
            description: translate(literals_1.default.TIMEOUT.MODAL_EXPIRED.DESCRIPTION),
            secondaryText: translate(literals_1.default.TIMEOUT.MODAL_EXPIRED.SECONDARY_LINK),
            primaryText: translate(literals_1.default.TIMEOUT.MODAL_EXPIRED.BUTTON_PRIMARY),
        },
    };
};
exports.useExpiredTimeout = useExpiredTimeout;
//# sourceMappingURL=useExpiredTimeout.js.map